import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Service } from '@api/models/B2bService/Contract/service';
import { Tariffs } from '@api/models/B2bService/Contract/tariffs';
import { SetB2BProgramRequest } from '@api/models/B2bService/Contract/set-b-2-b-program-request';
import { ProgramSingleProductFormField } from './program-single-product-form/program-single-product-form.service';
import { AbstractFormComponent } from '@ui/base/abstract-form/abstract-form.component';
import { B2BPartnerListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { B2bProgramType } from '../../../shared/models/b2b-program-type';


/**
 * Form b2b program add / edit
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-program-form',
    templateUrl: './program-form.component.html',
    styleUrls: ['./program-form.component.scss'],
    imports: [],
})
export class ProgramFormComponent extends AbstractFormComponent implements OnChanges {
    /**
     * B2b program id
     */
    @Input() public prgId: number;
    /**
     * List tickets
     */
    @Input() public partners: B2BPartnerListResponse[];
    /**
     * List tickets
     */
    @Input() public tickets: Tariffs[];
    /**
     * List services
     */
    @Input() public services: Service[];
    /**
     * Change service event
     *
     * @returns Service id
     */
    @Output() public changeService: EventEmitter<number> = new EventEmitter<number>();
    /**
     * Submit form event
     *
     * @returns Form data
     */
    @Output() public submitForm: EventEmitter<SetB2BProgramRequest> = new EventEmitter<SetB2BProgramRequest>();

    /**
     * B2b program type
     */
    @Input() public set b2bProgramType(b2bProgramType: B2bProgramType) {
        this.form.patchValue({
            prgType: b2bProgramType,
        });
    }

    /**
     * Partner name for edit mode
     */
    public prtName: string;
    /**
     * Tariff name for edit mode
     */
    public trfName: string;
    /**
     * Form object
     */
    public form: FormGroup;

    public get trfId(): AbstractControl {
        return this.form.get(ProgramSingleProductFormField.TrfId);
    }

    public ngOnChanges(): void {
        if (this.lyView) {
            this.form.disable();
        }
    }

    public handlerChangeService(service: Service): void {
        this.trfId.setValue(null);
        this.changeService.emit(service.srvId);
    }
}
